import * as React from 'react';
import { TLCode } from '../../common/enums';
import { Icon, Menu } from 'antd';
import { TranslatedMessage } from '../common/translation';
import { Link } from 'react-router-dom';
import { MenuItemProps } from 'antd/lib/menu/MenuItem';

export interface NavigationItemProps extends MenuItemProps {
  page?: string;
  icon: string;
  textTlCode: TLCode;
}

export class NavigationItem extends React.Component<NavigationItemProps> {
  render() {
    const { page, icon, textTlCode, ...restProps } = this.props;

    return (
      <Menu.Item {...restProps} key={page}>
        <Icon type={icon} />
        <span>
          <TranslatedMessage id={textTlCode} />
        </span>
        {page ? <Link to={page} /> : <></>}
      </Menu.Item>
    );
  }
}
